<template>

    <ModalAddParceria :isVisible="isVisibleModalAddParceria" @close="isVisibleModalAddParceria = false">
    </ModalAddParceria>

    <ModalEditParceria :parceria="parceriaEdit" :isVisible="isVisibleModalEditParceria"
        @close="isVisibleModalEditParceria = false"></ModalEditParceria>

    <div class="d-flex">

        <NavBarLeft path="/parcerias"></NavBarLeft>

        <div class="flex-1">

            <HeaderPage title="Parcerias" subtitle="Gerenciamento de parcerias"></HeaderPage>

            <div class="m-2 p-2 bg-white">
                <div class="mb-2 text-end d-flex gap-1 justify-content-end">

                    <ButtonField @click="isVisibleModalAddParceria = true" icon="ri-add-line" type="success"
                        size="small" text="Adicionar Parceria"></ButtonField>

                </div>
                <BaseTable :columns="dataTableHead" :rows="parceriasStore.parcerias"
                    :paginationOptions="{ perPage: 50 }">

                    <template #table-row="{ column, row }">

                        <!-- Coluna de Ações -->
                        <template v-if="column.field == '__actions'">

                            <span>
                                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6"
                                    placement="left-start">

                                    <div class="">
                                        <i class="ri-more-fill cursor-pointer"></i>
                                    </div>


                                    <template #popper>
                                        <div class="p-2 d-flex gap-2 flex-column">

                                            <OptionActionDataTable @click="openModalEditParceria(row)" text="Editar"
                                                icon="ri-pencil-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable @click="deletarParceria(row)" text="Deletar"
                                                icon="ri-delete-bin-line" textColor="danger">
                                            </OptionActionDataTable>

                                        </div>
                                    </template>
                                </DropdownFloating>
                            </span>

                        </template>

                        <!-- Colunas percentual de desconto -->
                        <template v-else-if="column.field == 'percentual_desconto'">
                            {{ row[column.field] }}%
                        </template>

                        <!-- Colunas normais -->
                        <template v-else>
                            {{ row[column.field] }}
                        </template>
                    </template>

                </BaseTable>

            </div>

        </div>

    </div>

</template>


<script>
import { useParceriasStore } from '@/stores/parcerias.js'
import ModalAddParceria from '@/components/modais/ModalAddParceria.vue'
import ModalEditParceria from '@/components/modais/ModalEditParceria.vue'
import { toast } from 'vue3-toastify'

export default {
    name: 'AppPage',
    data() {
        return {

            dataTableHead:
                [
                    { label: 'Id', field: 'id', tdClass: 'td-vertical-middle' },
                    { label: 'Nome', field: 'nome', tdClass: 'td-vertical-middle' },
                    { label: 'Percentual de desconto', field: 'percentual_desconto', tdClass: 'td-vertical-middle' },
                    { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
                ]
            ,

            isVisibleModalAddParceria: false,
            parceriasStore: useParceriasStore(),
            parceriaEdit: {},
            isVisibleModalEditParceria: false

        }
    },
    methods: {
        openModalEditParceria(parceria) {

            parceria.dropdownShown = false
            this.parceriaEdit = parceria
            this.isVisibleModalEditParceria = true

        },
        deletarParceria(parceria) {
            this.$swal({
                title: 'Tem certeza?',
                text: `Você realmente deseja deletar essa parceria? OBS: todos os usuário vinculados a essa parceria serão deletados também`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {

                    this.$notiflix.Loading.standard('Deletando Parceria')
                    const result = await this.parceriasStore.delete(parceria)
                    this.$notiflix.Loading.remove()

                    if (result.status) {
                        toast.success("Parceria deletada com sucesso")
                        this.parceriasStore.get()
                    } else {
                        toast.error(result.message)
                    }
                }
            })
        }
    },
    components: { ModalAddParceria, ModalEditParceria },
    mounted() {
        this.parceriasStore.get()
    }
}
</script>